import { z } from 'zod'

const ErrorBody = z.object({ ErrorCode: z.string() }).partial()

const ERROR_COPY: Record<string, string> = {
  OrderNotFound: 'This order is not available for this patient.',
  ShipmentNotFound: 'This order is not available for this patient.',
  ShipmentAlreadyDelivered: 'This shipment has already been delivered and cannot be changed.',
  ShipmentAlreadyVoided: 'This label has already been voided.',
  ShipmentConfirmNotAllowed: 'This shipment cannot be confirmed. Contact support if the issue persists.',
  UnknownOrderItem: 'The item list changed. We’ve refreshed it — review your selection and try again.',
  ShipEngineCommunicationError: 'Could not reach the shipping carrier. Please try again.',
  LabelVoidFailed: 'The void may have partially applied. Contact support before retrying.',
  OrderHasActiveLabel: 'This address can’t be changed while a shipping label is active. Void the label first.',
  IncompleteShippingAddressOverride: 'Please fill in all required address fields.',
  FulfillmentNotAllowed: 'This order can’t be sent to Scriptly in its current status.',
  OrderNotManagedPharmacy: 'This order isn’t filled by QuickMD Pharmacy.',
  FulfillmentAlreadySubmitted: 'Scriptly already has this order.',
}

function extractDetails(error: unknown): unknown {
  if (error !== null && typeof error === 'object' && 'details' in error) {
    return error.details
  }
  return undefined
}

export function getFulfillmentErrorCode(error: unknown): string | undefined {
  const details = extractDetails(error)
  const parsed = ErrorBody.safeParse(details)
  return parsed.success ? parsed.data.ErrorCode : undefined
}

export function getFulfillmentErrorMessage(error: unknown, fallback: string): string {
  const code = getFulfillmentErrorCode(error)
  if (code) {
    const copy = ERROR_COPY[code]
    if (copy) return copy
  }

  // Bodyless 404 (details is undefined/null) → same copy as OrderNotFound
  const details = extractDetails(error)
  if (error !== null && typeof error === 'object' && 'status' in error && error.status === 404 && !details) {
    return ERROR_COPY['OrderNotFound'] ?? fallback
  }

  return fallback
}
